import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

function Categories({ onSelect, value }) {
  const [selectedCategory, setSelectedCategory] = useState(value || "Reason for fight");

  const handleSelect = (eventKey) => {
    setSelectedCategory(eventKey);
    if (onSelect) {
      onSelect(eventKey);
    }
  };

  return (
    <DropdownButton
      id="reason-dropdown"
      title={selectedCategory}
      onSelect={handleSelect}
      variant="secondary"
      
    >
      <Dropdown.Item eventKey="Money">Money</Dropdown.Item>
      <Dropdown.Item eventKey="Communication">Communication</Dropdown.Item>
      <Dropdown.Item eventKey="Other">Other</Dropdown.Item>
    </DropdownButton>
  );
}

export default Categories;
